import React from "react";
import { Grid } from "@material-ui/core";
import MensagemMenuLateral from "features/manejo/views/components/MensagemMenuLateral";
import { useTranslations } from "adapters/i18n";
export const MensagemFazendaSemLotes = (props) => {

  const { t } = useTranslations();

  return (
    <Grid container spacing={0} id="gridContainer">
      <MensagemMenuLateral mensagem={t("statusIndicator:msg-without-category-or-animals")}>
        <img src="../images/map.svg" alt="icone de um mapa" />
      </MensagemMenuLateral>
      <div style={{ marginBottom: "60px" }} />
    </Grid>
  );
};

export default MensagemFazendaSemLotes;
